<template>
  <div>
    <div v-if="loaded">
      <b-row>
        <b-col lg="2">
          <label>Année de départ</label>
          <b-select v-model="range.start" @change="checkDate()">
            <b-select-option
              v-for="year in full_range.end - full_range.start + 1"
              :key="'start-' + year"
              :value="year - 1 + full_range.start"
              >{{ year - 1 + full_range.start }}</b-select-option
            >
          </b-select>
        </b-col>
        <b-col lg="2">
          <label>Année de fin</label>
          <b-select v-model="range.end" @change="checkDate()">
            <b-select-option
              v-for="year in full_range.end - range.start + 1"
              :key="'end-' + year"
              :value="year - 1 + range.start"
              >{{ year - 1 + range.start }}</b-select-option
            >
          </b-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" class="mt-3">
          <h6>
            Ventilation des paiements par numéro de compte
          </h6>
          <highcharts :options="chart_compte" ref="chart_compte"></highcharts>
        </b-col>
        <b-col lg="12" class="mt-3">
          <h6>
            Ventilation des paiements par mois
          </h6>
          <highcharts :options="chart_flow" ref="chart_flow"></highcharts>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import payments from "@/services/payments.js";
import { Chart } from "highcharts-vue";
export default {
  name: "financial-flow",
  components: {
    highcharts: Chart,
  },

  data() {
    return {
      mouvements: {},
      loaded: false,
      range: {
        start: null,
        end: null,
      },
      full_range: {
        start: null,
        end: null,
      },
      chart_compte: {},
      chart_flow: {},
    };
  },
  created() {
    this.load();
  },
  methods: {
    checkDate() {
      if (this.range.start > this.range.end) {
        this.range.end = this.range.start;
      }
      this.reload();
    },
    reload() {
      payments.getFlow(this.range.start, this.range.end).then((response) => {
        this.mouvements = response.data;
        this.createCharts();
        this.loaded = true;
      });
    },
    load() {
      payments.getFlow().then((response) => {
        this.mouvements = response.data;
        this.full_range = this.mouvements.stats.full_range;
        this.range.start = this.mouvements.stats.range.start;
        this.range.end = this.mouvements.stats.range.end;
        this.createCharts();

        this.loaded = true;
      });
    },
    createCharts() {
      this.chart_compte = {
        chart: {
          type: "column",
        },
        title: {
          text: "Paiements par n° de compte",
        },
        xAxis: {
          categories: this.mouvements.stats.compte.map((x) => x.compte),
          tickmarkPlacement: "on",
          title: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            text: "Montant total",
          },
        },
        tooltip: {
          split: true,
          pointFormat: "{series.name}: {point.y} €",
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: "Montant",
            data: this.mouvements.stats.compte.map((x) => Number(x.total)),
          },
        ],
      };
      this.chart_flow = {
        chart: {
          type: "area",
        },
        title: {
          text: "Paiements par mois",
        },
        xAxis: {
          categories: this.mouvements.flow.data.map((x) => x.date),
          tickmarkPlacement: "on",
          title: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            text: "Montant total",
          },
        },
        tooltip: {
          split: true,
          pointFormat: "{series.name}: {point.y} €",
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: "Montant",
            data: this.mouvements.flow.data.map((x) => Number(x.total)),
          },
        ],
      };
    },
  },
};
</script>